type ShellState = {
    currentLanguage: string;
};

const initialShellState: ShellState = {
    currentLanguage: 'pt-PT'
};

const shellReducer = (state: ShellState = initialShellState): ShellState => state;

export default shellReducer;
